import script from "./classDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./classDialog.vue?vue&type=script&setup=true&lang=js"

import "./classDialog.vue?vue&type=style&index=0&id=7da9c9b1&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7da9c9b1"]])

export default __exports__